// Angular
import { COMMA, ENTER } from '@angular/cdk/keycodes'
import { ChangeDetectorRef, Component, Inject, OnInit, ViewChild, ElementRef } from '@angular/core'
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material'
import { FormControl, FormGroupDirective, NgForm, Validators } from '@angular/forms'
import { ErrorStateMatcher } from '@angular/material/core'
import { formatDate } from '@angular/common'
import { Stringable, StringableValues } from '../../../../../common/stringable.decorator'
import { Observable, BehaviorSubject} from "rxjs"
import { debounceTime, distinctUntilChanged } from 'rxjs/operators'
// Services
import { ConsultationService, AppService, DialogService, StateService,TiersService, VisiteService } from '../../../../../services'
import * as moment from 'moment'
//Component
import { BaseDialogComponent } from '../../../../../base/dialog-base/dialog-base.component'
import { ConfirmComponent } from '../confirm-dialog/confirm.component'

//Interfaces
import { JSONRpcResponse } from '../../../../../Interfaces/JSONRpcResponse'
import { cpuUsage } from 'process'
import { ConsultationSingleComponent } from '../../../content/consultation/consultation-single/consultation-single.component'

const KEY = 'consultation-move-dialog'

export class MyErrorStateMatcher implements ErrorStateMatcher {
	isErrorState(
		control: FormControl | null,
		form: FormGroupDirective | NgForm | null
	): boolean {
		const isSubmitted = form && form.submitted
		return !!(
			control &&
			control.invalid &&
			(control.dirty || control.touched || isSubmitted)
		)
	}
}

@Component({
	selector: 'atyl-consultation-move',
	templateUrl: './consultation-move.component.html',
	styleUrls: ['./consultation-move.component.scss']
})
@Stringable({
	path: 'views/partials/layout/dialogs/consultation-move-dialog',
	key: KEY,
})
export class ConsultationMoveComponent extends BaseDialogComponent implements OnInit {

	@StringableValues(KEY)
  	strings: any;

	dateFilter: any=(d: Date): boolean => {/* Prevent Saturday and Sunday for select. */
		const day = d.getDay();
		return day !== 0 && day !== 6 ;
    }

	selection:boolean = true;
	dateBool:boolean = false;
	drawerRightIsOpen: boolean = false;
	toLoadConsultion:BehaviorSubject<boolean>=new BehaviorSubject<boolean>(false);

	radio_list=['Professionnel','Tiers'];
	radio_pick:any;

	radio_type=['Séance','Domicile','Non planifié'];
	radio_typePick:any='Séance'

	titre:any;
	comment:any;

	typeFormControl = new FormControl('', [Validators.required]);
	locationFormControl = new FormControl('', [Validators.required]);
	tiersControl = new FormControl('', [Validators.required]);
	consultFormControl = new FormControl('', [Validators.required]);

	matcher = new MyErrorStateMatcher();

	consultation:any;
	consultationInput:any;
	consultationGroup = [];
	consultationLocation = [];

	errors:any =[]
	errorMessage:string ="";

	etats = [];
	etatCree = [];
	etatDel:any;
	tiersSearchList = [];
	tiersSearchIsEmpty = true;
	tiersId = [];
	tiersSelected = [];
	suiviSearchTerm: string

	minuteIntervalInput:any;
	statusInput: any;
	typeInput : any;
	locationInput:any;
	consultInput:any;
	removable: boolean = true;

	separatorKeysCodes: number[] = [ENTER, COMMA];

	valueDebut: any = '08:00';
    valueFin: any = '17:00';
	invalidDate = false;
	startTimeInput: any;
	endTimeInput: any;
	dateAjd:Date;
	dateMois:Date;

	OptionSelected = {
		domicile:0,
		ponctuel:0,
		initiative:null,
		type:null,
		date:null,
		etat:null,
		etatDel:null,
		heureDebut:null,
		heureFin:null,
		tiersID:null,
		intervalle:null,
		lieuID:null,
		commentaire:null,
		titre:null,
	}
	options:any = [];

	@ViewChild('professionalInput', { read: undefined, static: undefined })
	professionalInput: ElementRef<HTMLInputElement>

	constructor(
		public dialogRef: MatDialogRef<ConsultationMoveComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any,
		private appService: AppService,
		changeDetectorRef: ChangeDetectorRef,
		dialogService: DialogService,
		private consultationService: ConsultationService,
		private tiersService: TiersService,
		public dialog: MatDialog,
		private visiteService: VisiteService,
	 
	) {
		super(dialogRef, dialogService, changeDetectorRef)
	}

	ngOnInit() {
		if(this.data.object == 'consultation'){
			this.strings.title = 'Déplacer Séance(s)'
			this.dialogRef.updateSize("800px","350px")
		} else if(this.data.object == 'visite'){
			this.strings.title = 'Déplacer RDV(s)'
			this.dialogRef.updateSize("800px","250px")
		}
		

		this.startTimeInput=this.valueDebut;
        this.endTimeInput=this.valueFin;

		this.OptionSelected.heureDebut = this.valueDebut;
		this.OptionSelected.heureFin = this.valueFin;

		
	
		this.consultationService.etats().subscribe((res: JSONRpcResponse) => {
			if (res.result) {
				this.etats=res.result;
				this.etatCree = res.result[2];
				this.OptionSelected.etat = this.etatCree;
				this.etatDel = res.result[3];
				this.OptionSelected.etatDel = this.etatDel.key
				for(let i=0;i<this.etats.length;i++) {
					if (this.consultation && this.etats[i].key==this.consultation.etat.key) {
					this.statusInput=this.etats[i];
					}
					else {
						if (this.etats[i].key=="CREE")
							this.statusInput=this.etats[i];
							
					}      
				}
				this.changeDetectorRef.detectChanges()
			}
 		})	
		console.log(this) 
	}

	changeTypeGroup(type){
		if(this.OptionSelected.type != undefined)
			this.resetForm();
		if(typeof type === 'object'){
			if(type.lieux)
			this.loadConsultationLocations(type.lieux)
			this.OptionSelected.type = type;
		}
		this.subscriptions.push(this.consultationService.getConsultationTypeGroupe(type.ID).subscribe((res: JSONRpcResponse) => {
			this.consultationGroup = res.result
			this.tiersSearchIsEmpty = false
		}),
		this.tiersControl.valueChanges.pipe(debounceTime(400), distinctUntilChanged()).subscribe((term) => {
			this.tiersService.getTiersByConsultationType(type.ID, {tiersId: this.tiersId,term: term}).subscribe((res: JSONRpcResponse) => {
					this.tiersSearchList = res.result
					this.changeDetectorRef.detectChanges()
				})
			})
		)
	}

	loadConsultationLocations(lieux: any) {
		if (lieux != undefined && lieux.length > 0) {
			this.subscriptions.push(this.tiersService.searchByType(lieux).subscribe((res: JSONRpcResponse) => {
				res.result.forEach((result: any) => {
					let ll={
						nom: result.NOM ? result.NOM : '',
						number: (result.adresses != undefined && result.adresses.PRINCIPALE != undefined && result.adresses.PRINCIPALE.number) ? result.adresses.PRINCIPALE.number : '',
						complement: (result.adresses != undefined && result.adresses.PRINCIPALE != undefined && result.adresses.PRINCIPALE.complement) ? result.adresses.PRINCIPALE.complement : '',
						street: (result.adresses != undefined && result.adresses.PRINCIPALE != undefined && result.adresses.PRINCIPALE.street) ? result.adresses.PRINCIPALE.street : '',
						zipCode: (result.adresses != undefined && result.adresses.PRINCIPALE != undefined && result.adresses.PRINCIPALE.IDzipcode) ? result.adresses.PRINCIPALE.IDzipcode : '',
						town: (result.adresses != undefined && result.adresses.PRINCIPALE != undefined && result.adresses.PRINCIPALE.town) ? result.adresses.PRINCIPALE.town : '',
						ID: result.ID ? result.ID : ''
					};
					
					this.consultationLocation = [];
					this.consultationLocation.push(ll)
					
					if (this.consultation!=undefined
						&& this.consultation
						&& this.consultation.lieu!=undefined 
						&& this.consultation.lieu
						&& ll.ID==this.consultation.lieu.ID
						) {
							this.locationInput=ll.ID;
						}
						this.changeDetectorRef.detectChanges()
				})
			}))
		}
	}

	changeDate(event: any) {
		if (event.value) {
			if (moment.isDate(event.value)) {
				this.invalidDate = false
				this.OptionSelected.date = event.value;
			} else {
				this.invalidDate = true
			}
		} else {
			this.invalidDate = true
		}
	}

	changeEtat(event){
		this.OptionSelected.etat = event;
	}

	selectTiers(tiers: any) {
		if (this.tiersSelected.indexOf(tiers) === -1) {
			this.tiersSelected.push(tiers)
		}
		this.suiviSearchTerm = ''
		this.tiersSearchList = []
		this.changeDetectorRef.detectChanges()
	}

	supprimer(tiers: any) {
		const index = this.tiersSelected.indexOf(tiers)
		const indexId = this.tiersId.indexOf(tiers.ID)
		if (index >= 0) {
			this.tiersSelected.splice(index, 1)
		}
		if (indexId >= 0) {
			this.tiersId.splice(indexId, 1)
		}
		this.changeDetectorRef.detectChanges()
	}

	ajouter(event: any) {
		const value = (event.value || '').trim()
		if (value) {
			this.tiersSelected.push(value)
		}
		event.chipInput.clear()
		this.tiersControl.setValue(null)
	}

	selected(event: any) {
		this.OptionSelected.tiersID = event.option.value.ID
		this.tiersSelected.push(event.option.value)
		this.tiersId.push(event.option.value.ID)
		this.professionalInput.nativeElement.value = ''
		this.tiersControl.setValue(null)
		this.changeDetectorRef.detectChanges()
	}

	timeChange(event: any, position: any) {
		if (position === 'debut') {
			this.OptionSelected.heureDebut = event;
			this.startTimeInput = event
		} else {
			this.OptionSelected.heureFin = event;
			this.endTimeInput = event
		}
	}

	changeLieu(event){
		this.OptionSelected.lieuID = event;
	}

	changeIntervalle(event){
		this.OptionSelected.intervalle = event;
	}

	toggle(pos: string) {
		if (pos == 'right') {
			this.drawerRightIsOpen = !this.drawerRightIsOpen
			if (this.drawerRightIsOpen) {
				console.log("toggle slider");
				this.toLoadConsultion.next(true);
			}
		}
		this.changeDetectorRef.detectChanges();
	}

	resetForm(){
		if(this.statusInput != undefined || this.statusInput != null)
			this.statusInput = null;
			this.OptionSelected.etat = this.etatCree;

		if(this.locationInput != undefined || this.locationInput != null)
			this.locationInput = null;
			this.OptionSelected.lieuID = undefined;

		if(this.minuteIntervalInput != undefined || this.minuteIntervalInput != null)
			this.minuteIntervalInput = null;
			this.OptionSelected.intervalle = undefined;
		
		if(this.tiersSearchList != undefined || this.tiersSearchList != null){
			this.tiersSelected = [];
			this.tiersId = [];
			this.tiersSearchList = null;
			this.tiersControl.setValue(null);
			this.OptionSelected.tiersID = undefined;
		}
		this.changeDetectorRef.detectChanges()
	}

	switchTemplate(){
		this.resetForm();
		this.consultInput = null;
		this.errors=[];
		this.errorMessage="";

		if(this.selection == true){
			this.dialogRef.updateSize("800px","670px")
			this.selection = false
		} else {
			this.dialogRef.updateSize("800px","350px")
			this.selection = true
		}
		this.changeDetectorRef.detectChanges()
	}

	consultPick(event) {
		if(event && event!=null){
			this.consultationInput = event
			this.selection = true;
			if(this.dateBool == false){
				this.dialogRef.updateSize("800px","400px")
				this.dateBool = true
				this.changeDetectorRef.detectChanges()
			}
		}

	}

	moveConsultation(){
		this.errors=[];
		this.errorMessage="";

		if (!this.radio_pick)
			this.errors.push("Initiative");
		if (!this.consultationInput)
			this.errors.push("Séance");
		if (this.errors.length>0) {
			this.errorMessage="<ul><li>"+this.errors.join("</li><li>")+"</li></ul>";
			this.changeDetectorRef.detectChanges();
		} else {
			let toConfirm = true;
			let nbConsult = this.data.nbConsult;
			if(toConfirm == true){
				const confDialogRef = this.dialog.open(ConfirmComponent, {
					data : {
						libelle : "Etes-vous sûr de vouloir modifier "+nbConsult+" séance(s)"
					}
				});
				confDialogRef.afterClosed().subscribe(res => {
					if(res === "true"){
						if(this.selection){
							if (this.consultationInput != undefined) {
								let dateDebut = new Date(this.consultationInput.date_debut);
								let dateFin = new Date(this.consultationInput.date_fin)
								
								let begin = formatDate(dateDebut, 'MM/dd/yyyy', 'en')
								let end = formatDate(dateFin, 'MM/dd/yyyy', 'en')
								
								let startTime = new Date(begin + ' ' + this.startTimeInput)
								let endTime = new Date(end + ' ' + this.endTimeInput)

								let dataReturn = {
									method: 'Déplacer',
									consultationid:this.consultationInput.ID,
									options: {
										domicile:0,
										ponctuel:0,
										initiative:this.radio_pick,
										etatCree:this.etatCree,
										etatDel:this.etatDel,
										datedebut: startTime,
										datefin: endTime,
										titre: this.titre? this.titre:null,
										commentaire: this.comment? this.titre:null
									}
								}
								if (this.radio_typePick == 'Domicile') {
									dataReturn.options.domicile = 1;
									dataReturn.options.ponctuel = 0;
								} else if (this.radio_typePick == 'Non planifié') {
									dataReturn.options.domicile = 0;
									dataReturn.options.ponctuel = 1;
								} else {
									dataReturn.options.domicile = 0;
									dataReturn.options.ponctuel = 0;
								} 
								this.dialogRef.close(dataReturn);
							}
						} 
					}
				})
			}
		}
		
	}

	createConsultation(){
		this.errors=[];
		this.errorMessage="";

		if (!this.radio_pick)
			this.errors.push("Initiative");
		else 
			this.OptionSelected.initiative = this.radio_pick.toString();

		if (!this.OptionSelected.type)
			this.errors.push("Type");
        if (!this.OptionSelected.date)
			this.errors.push("Date");
        if (!this.OptionSelected.etat)
			this.errors.push("Etat");
		if(!this.OptionSelected.tiersID)
			this.errors.push("Professionnel")
		if (!this.OptionSelected.lieuID)
			this.errors.push("Lieu");
		if (!this.OptionSelected.heureDebut)
			this.errors.push("Heure début");
        if (!this.OptionSelected.heureFin)
			this.errors.push("Heure fin");
        if (this.errors.length>0) {
            this.errorMessage="<ul><li>"+this.errors.join("</li><li>")+"</li></ul>";
            this.changeDetectorRef.detectChanges();
        } else {
			let toConfirm = true;
			let nbConsult = this.data.nbConsult;
			if(toConfirm == true){
				const confDialogRef = this.dialog.open(ConfirmComponent, {
					data : {
						libelle : "Etes-vous sûr de vouloir modifier "+nbConsult+" séance(s)"
					}
				});
				confDialogRef.afterClosed().subscribe(res => {
					if(res === "true"){ 
						if (this.selection == false){
							let date = formatDate(this.OptionSelected.date, 'MM/dd/yyyy', 'en')
							let datedebut = new Date(date + ' ' + this.OptionSelected.heureDebut)
							let datefin = new Date(date + ' ' + this.OptionSelected.heureFin)

							if(this.titre) 
								this.OptionSelected.titre = this.titre ? this.titre:null;

							if(this.comment)
								this.OptionSelected.commentaire = this.comment ? this.comment:null;

							let dataReturn = {
								method: 'Créer',
								options:this.OptionSelected,
								datedebut:datedebut,
								datefin:datefin
							}

							if (this.radio_typePick == 'Domicile') {
								dataReturn.options.domicile = 1;
								dataReturn.options.ponctuel = 0;
							} else if (this.radio_typePick == 'Non planifié') {
								dataReturn.options.domicile = 0;
								dataReturn.options.ponctuel = 1;
							} else {
								dataReturn.options.domicile = 0;
								dataReturn.options.ponctuel = 0;
							} 
							this.dialogRef.close(dataReturn);
						}
					}
				})
			}
		}
	}

}
